import csrf from "@/utils/csrfToken";

export default async function sendPostRequest(url = '', data = {}) {
    const csrfToken = await new csrf().getCsrfToken();
    data[csrfToken.name] = csrfToken.value;
    const response = await fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    });
    return {
        status: response.status,
        json: await response.json(),
    };
}
